import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingScreen from 'components/LoadingScreen';

const AdminGuard = ({ children }) => {
  const navigate = useNavigate();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('gpo_admin_token');
    if (!token) {
      navigate('/login', { replace: true });
    } else {
      setIsReady(true);
    }
  }, [navigate]);

  if (!isReady) return <LoadingScreen />;

  return children;
};

AdminGuard.propTypes = {
  children: PropTypes.node
};

export default AdminGuard;
